import { render, staticRenderFns } from "./VBase.vue?vue&type=template&id=575d76d0&scoped=true"
import script from "./VBase.vue?vue&type=script&lang=js"
export * from "./VBase.vue?vue&type=script&lang=js"
import style0 from "./VBase.vue?vue&type=style&index=0&id=575d76d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d76d0",
  null
  
)

export default component.exports